import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { uploadI9Document, ListDocuments } from 'api/user'

export function useUploadI9DocumentMutation(
  userId: string,
  options?: UseMutationOptions<any, Error, ListDocuments, unknown>
) {
  return useMutation({
    mutationFn: (payload) => uploadI9Document(userId, payload),
    ...options,
  })
}
